import { compose } from 'redux';

import { FieldInputType } from 'constants/fields';
import { FieldType } from 'constants/formGenerator';
import { fillConfigFieldsWithKeys } from 'utils/loanManagement';

import { OtherExpensesInfo } from '../OtherExpenses.constants';

const configFields = {
  name: {
    fieldId: 'name',
    type: FieldType.INPUT,
    nameInModel: `name`,
    inputProps: {
      label: 'Name',
      placeholder: 'Name',
      variant: 'outlined',
      type: FieldInputType.TEXT,
      required: true,
    },
  },
  value: {
    fieldId: 'value',
    type: FieldType.INPUT,
    nameInModel: `value`,
    inputProps: {
      label: 'Amount',
      placeholder: 'Amount',
      variant: 'outlined',
      type: FieldInputType.CURRENCY,
      minValue: 0,
      required: true,
    },
  },
};

export const getOtherExpenseConfig = compose(fillConfigFieldsWithKeys, () => {
  return {
    groups: [
      {
        type: FieldType.GROUP,
        fields: [configFields.name, configFields.value],
        key: OtherExpensesInfo.KEY,
      },
    ],
  };
});
